module.exports = __webpack_public_path__ + "6a817f9112fa77b2c2478441cc69e803.jpg";